import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/styles/index.css'

Vue.config.productionTip = process.env.VUE_APP_ENV === 'development'
Vue.config.devtools = process.env.VUE_APP_ENV === 'development'
Vue.config.debug = process.env.VUE_APP_ENV === 'development'
Vue.config.silent = process.env.VUE_APP_ENV !== 'development'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
